export enum MenuItemVariant {
  DEFAULT = "DEFAULT",
  RED = "RED",
}
